const errorMap: { [key: string]: string } = {
  api: `API is not supported in ${__platform} platform`,
}
export function throwErrorMsg(apiName: string, errorType = "api"): Error {
  if (!apiName) return
  throw Error(`max.${apiName}: ${errorMap[errorType]}`)
}
export function logWarnMsg(apiName: string, errorType = "api") {
  console.warn(`max.${apiName}: ${errorMap[errorType]}`)
}
